import { AppBar, Typography } from "@mui/material";
import Layout from "./Layout";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <AppBar
      position="static"
      color="primary"
      sx={{ top: "auto", bottom: 0, background: "black", height: "150px" }}
    >
      <Layout>
        <Typography textAlign={"center"}>
          © {currentYear} | All rights reserved | Privacy Policy
        </Typography>
      </Layout>
    </AppBar>
  );
}
